import { useCallback, useEffect, useState } from "react";

function getIsIOS(): boolean {
  if (typeof navigator === "undefined") return false;
  return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}

function getIsPWA(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(display-mode: standalone)").matches ||
    (window.navigator as any).standalone === true;
}

export function useFullscreen() {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const isIOS = getIsIOS();
  const isPWA = getIsPWA();

  useEffect(() => {
    const handleChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleChange);
    return () => document.removeEventListener("fullscreenchange", handleChange);
  }, []);

  const toggleFullscreen = useCallback(async () => {
    if (isIOS) return; // Fullscreen API not supported on iOS
    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen();
      } else {
        await document.exitFullscreen();
      }
    } catch (err) {
      console.warn("Fullscreen not supported:", err);
    }
  }, [isIOS]);

  const isSupported = typeof document !== "undefined" && 
    !!document.documentElement.requestFullscreen && 
    !isIOS;

  return { isFullscreen, toggleFullscreen, isSupported, isIOS, isPWA };
}
